import { State } from '~/services/api/enums';

const stateOptions = [
  {
    value: State.Alabama,
    label: 'Alabama',
  },
  {
    value: State.Alaska,
    label: 'Alaska',
  },
  {
    value: State.Arizona,
    label: 'Arizona',
  },
  {
    value: State.Arkansas,
    label: 'Arkansas',
  },
  {
    value: State.California,
    label: 'California',
  },
  {
    value: State.Colorado,
    label: 'Colorado',
  },
  {
    value: State.Connecticut,
    label: 'Connecticut',
  },
  {
    value: State.Delaware,
    label: 'Delaware',
  },
  {
    value: State.DistrictOfColumbia,
    label: 'District Of Columbia',
  },
  {
    value: State.Florida,
    label: 'Florida',
  },
  {
    value: State.Georgia,
    label: 'Georgia',
  },
  {
    value: State.Hawaii,
    label: 'Hawaii',
  },
  {
    value: State.Idaho,
    label: 'Idaho',
  },
  {
    value: State.Illinois,
    label: 'Illinois',
  },
  {
    value: State.Indiana,
    label: 'Indiana',
  },
  {
    value: State.Iowa,
    label: 'Iowa',
  },
  {
    value: State.Kansas,
    label: 'Kansas',
  },
  {
    value: State.Kentucky,
    label: 'Kentucky',
  },
  {
    value: State.Louisiana,
    label: 'Louisiana',
  },
  {
    value: State.Maine,
    label: 'Maine',
  },
  {
    value: State.Maryland,
    label: 'Maryland',
  },
  {
    value: State.Massachusetts,
    label: 'Massachusetts',
  },
  {
    value: State.Michigan,
    label: 'Michigan',
  },
  {
    value: State.Minnesota,
    label: 'Minnesota',
  },
  {
    value: State.Mississippi,
    label: 'Mississippi',
  },
  {
    value: State.Missouri,
    label: 'Missouri',
  },
  {
    value: State.Montana,
    label: 'Montana',
  },
  {
    value: State.Nebraska,
    label: 'Nebraska',
  },
  {
    value: State.Nevada,
    label: 'Nevada',
  },
  {
    value: State.NewHampshire,
    label: 'New Hampshire',
  },
  {
    value: State.NewJersey,
    label: 'New Jersey',
  },
  {
    value: State.NewMexico,
    label: 'New Mexico',
  },
  {
    value: State.NewYork,
    label: 'New York',
  },
  {
    value: State.NorthCarolina,
    label: 'North Carolina',
  },
  {
    value: State.NorthDakota,
    label: 'North Dakota',
  },
  {
    value: State.Ohio,
    label: 'Ohio',
  },
  {
    value: State.Oklahoma,
    label: 'Oklahoma',
  },
  {
    value: State.Oregon,
    label: 'Oregon',
  },
  {
    value: State.Pennsylvania,
    label: 'Pennsylvania',
  },
  {
    value: State.RhodeIsland,
    label: 'Rhode Island',
  },
  {
    value: State.SouthCarolina,
    label: 'South Carolina',
  },
  {
    value: State.SouthDakota,
    label: 'South Dakota',
  },
  {
    value: State.Tennessee,
    label: 'Tennessee',
  },
  {
    value: State.Texas,
    label: 'Texas',
  },
  {
    value: State.Utah,
    label: 'Utah',
  },
  {
    value: State.Vermont,
    label: 'Vermont',
  },
  {
    value: State.Virginia,
    label: 'Virginia',
  },
  {
    value: State.Washington,
    label: 'Washington',
  },
  {
    value: State.WestVirginia,
    label: 'West Virginia',
  },
  {
    value: State.Wisconsin,
    label: 'Wisconsin',
  },
  {
    value: State.Wyoming,
    label: 'Wyoming',
  },
];

export default stateOptions;
